import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

export function CustomTabPanel(props) {
  const { children, value, index, sx, stacked = false, ...other } = props;
  const isActive = value === index;
  const visible = stacked || isActive;

  return (
    <Box
      role="tabpanel"
      hidden={!visible}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        pt: 1,
        ...sx,
        // Active-state behavior is enforced AFTER caller sx — a caller's
        // `display: "flex"` must never override tab visibility (that made
        // every panel render at once, each squeezed to a fraction of the
        // height). In `stacked` mode (mobile), all panels render with their
        // natural height instead of flex-splitting the container. NOTE: a
        // numeric flex shorthand like `flex: 0` resolves to `flex-basis: 0%`,
        // which overrides `height: auto` whenever the scroll container has a
        // definite height, collapsing the panel to 0px (its content then
        // paints on top of the next section). `flex: "none"` (basis auto)
        // keeps the natural height in every container.
        display: visible ? "flex" : "none",
        flexDirection: "column",
        flex: stacked ? "none" : visible ? 1 : 0,
        minHeight: 0,
        height: stacked ? "auto" : "100%",
        // Stacked (mobile) mode pours every section into one scroll
        // container. Give each section after the first a top divider and
        // spacing so consecutive sections read as separate blocks instead
        // of one scrambled stream (2026-10-16).
        ...(stacked && index > 0
          ? {
              borderTop: 1,
              borderColor: "divider",
              mt: 2,
              pt: 2,
            }
          : {}),
      }}
      {...other}
    >
      {visible && children}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
